export const BRANG_ENUM = [
  {
    value: "1",
    label: "京瓷",
    iframeUrl: "https://www.kyocera.com.cn/prdct/cuttingtool/category/product",
    children: [
      {
        value: "1-1",
        label: "车削刀片",
      },
      {
        value: "1-2",
        label: "车削刀杆",
      },
      {
        value: "1-3",
        label: "切槽・螺纹・切断工具",
      },
      {
        value: "1-4",
        label: "金刚石・CBN・陶瓷",
      },
      {
        value: "1-5",
        label: "小零件工具",
      },
      {
        value: "1-6",
        label: "铣削工具",
      },
      {
        value: "1-7",
        label: "钻孔工具",
      },
      {
        value: "1-8",
        label: "整体式立铣工具",
      },
      {
        value: "1-9",
        label: "非标工具",
      },
    ],
  },
  {
    value: "2",
    label: "瓦格斯",
    iframeUrl:
      "https://www.vargus.com/zh-hans-cn/shop/?unit=metric&tooling=mm&productStandard=iso&s=single",
    children: [
      {
        value: "1-1",
        label: "外螺纹车削-刀片",
      },
      {
        value: "1-2",
        label: "外螺纹车削-刀杆",
      },
      {
        value: "1-3",
        label: "内螺纹车削-刀片",
      },
      {
        value: "1-4",
        label: "内螺纹车削-刀杆",
      },
    ],
  },
  {
    value: "3",
    label: "泰珂洛",
    iframeUrl: "https://tungaloy.com/cn/products/turning/",
    children: [
      {
        value: "1-1",
        label: "车削-外圆车削",
      },
      {
        value: "1-2",
        label: "车削-内孔车削",
      },
      {
        value: "1-3",
        label: "车削-小零件加工",
      },
      {
        value: "1-4",
        label: "车削-螺纹加工",
      },
      {
        value: "1-5",
        label: "切断切槽",
      },
      {
        value: "1-6",
        label: "铣削-大进给铣削",
      },
      {
        value: "1-7",
        label: "铣削-平面铣削",
      },
      {
        value: "1-8",
        label: "铣削-方肩铣削",
      },
      {
        value: "1-9",
        label: "铣削-槽铣削",
      },
      {
        value: "1-10",
        label: "铣削-仿形铣削",
      },
      {
        value: "1-11",
        label: "钻削-四刃钻头",
      },
      {
        value: "1-12",
        label: "钻削-双排屑槽钻头",
      },
    ],
  },
  {
    value: "4",
    label: "金鹭",
    iframeUrl:
      "https://imall.cxtc.com/#/product/productSecond?catalogueCode=21",
    children: [
      {
        value: "1-1",
        label: "车削加工",
        children: [
          {
            value: "211001",
            label: "普通车削刀片",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=211001&parentCode=21",
          },
          {
            value: "211002",
            label: "普通车削刀杆",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=211002&parentCode=21",
          },
        ],
        imageSrc:
          "	https://imall.cxtc.com//ImagesFile/filesProd/images/catalogue/2110_%E8%BD%A6%E5%89%8A.jpg",
      },
      {
        value: "1-2",
        label: "螺纹加工",
        children: [
          {
            value: "212001",
            label: "螺纹车削刀片",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=212001&parentCode=21",
          },
          {
            value: "212002",
            label: "螺纹车削刀杆",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=212002&parentCode=21",
          },
        ],
        imageSrc:
          "https://imall.cxtc.com//ImagesFile/filesProd/images/catalogue/2120_%E8%9E%BA%E7%BA%B9.jpg",
      },
      {
        value: "1-3",
        label: "切断切槽",
        children: [
          {
            value: "213001",
            label: "切断切槽刀片",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=213001&parentCode=21",
          },
          {
            value: "213001",
            label: "切断切槽刀杆",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=213001&parentCode=21",
          },
        ],
        imageSrc:
          "	https://imall.cxtc.com//ImagesFile/filesProd/image…gue/2130_%E5%88%87%E6%96%AD%E5%88%87%E6%A7%BD.jpg",
      },
      {
        value: "1-4",
        label: "铣削加工",
        children: [
          {
            value: "214001",
            label: "整体硬质合金立铣刀",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=214001&parentCode=21",
          },
          {
            value: "214002",
            label: "可转位铣削刀片",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=214002&parentCode=21",
          },
          {
            value: "214003",
            label: "可转位铣削刀体",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=214003&parentCode=21",
          },
        ],
        imageSrc:
          "	https://imall.cxtc.com//ImagesFile/filesProd/images/catalogue/2140_%E9%93%A3%E5%89%8A.jpg",
      },
      {
        value: "1-5",
        label: "孔加工",
        children: [
          {
            value: "215001",
            label: "整体硬质合金钻头",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=215001&parentCode=21",
          },
          {
            value: "215002",
            label: "可转位孔加工刀片",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=215002&parentCode=21",
          },
          {
            value: "215003",
            label: "可转位孔加工刀体",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=215003&parentCode=21",
          },
          {
            value: "215004",
            label: "小径镗刀",
            url: "https://imall.cxtc.com/#/product/productThird?catalogueCode=215004&parentCode=21",
          },
        ],
        imageSrc:
          "https://imall.cxtc.com//ImagesFile/filesProd/images/catalogue/2150_%E5%AD%94%E5%8A%A0%E5%B7%A5.jpg",
      },
      {
        value: "1-6",
        label: "小零件加工",
        imageSrc:
          "https://imall.cxtc.com//ImagesFile/filesProd/images/catalogue/2160_%E5%B0%8F%E9%9B%B6%E4%BB%B6.jpg",
      },
      {
        value: "1-7",
        label: "超硬刀具",
        imageSrc:
          "https://imall.cxtc.com//ImagesFile/filesProd/image…gue/2170_%E8%B6%85%E7%A1%AC%E5%88%80%E5%85%B7.jpg",
      },
      {
        value: "1-8",
        label: "工具系统及配件",
        imageSrc:
          "https://imall.cxtc.com//ImagesFile/filesProd/image…%E7%B3%BB%E7%BB%9F%E5%8F%8A%E9%85%8D%E4%BB%B6.jpg",
      },
      {
        value: "1-9",
        label: "丝锥",
        imageSrc:
          "https://imall.cxtc.com//ImagesFile/filesProd/images/catalogue/2190_%E4%B8%9D%E9%94%A5.jpg",
      },
    ],
  },
  {
    value: "5",
    label: "住友",
    iframeUrl: "https://www.sumitool.com/cn/products/cutting-tools/",
    children: [
      {
        value: "1-1",
        label: "切削刀具-材质",
        url: "http://html.szktr.cn/cutting-tools-inserts-grades.html",
      },
      {
        value: "1-2",
        label: "切削刀具-断屑槽",
        url: "http://html.szktr.cn/cutting-tools-inserts-chipbreakers.html",
      },
      {
        value: "1-3",
        label: "外径车刀",
        url: "http://html.szktr.cn/cutting-tools-holders-external.html",
      },
      {
        value: "1-4",
        label: "内径车刀",
        url: "http://html.szktr.cn/cutting-tools-holders-boring-bars.html",
      },
      {
        value: "1-5",
        label: "切槽/切断/螺纹加工",
        url: "http://html.szktr.cn/cutting-tools-grooving-cut-off-threading.html",
      },
      {
        value: "1-6",
        label: "小型刀具",
        url: "http://html.szktr.cn/cutting-tools-small-tools.html",
      },
      {
        value: "1-7",
        label: "铣刀",
        url: "http://html.szktr.cn/cutting-tools-milling-cutters.html",
      },
      {
        value: "1-8",
        label: "立铣刀",
        url: "http://html.szktr.cn/cutting-tools-endmills.html",
      },
      {
        value: "1-9",
        label: "钻头",
        url: "http://html.szktr.cn/cutting-tools-drills.html",
      },
      {
        value: "1-10",
        label: "CBN/PCD",
        url: "http://html.szktr.cn/cutting-tools-cbn-pcd.html",
      },
    ],
  },
  {
    value: "6",
    label: "YAMAWA",
    iframeUrl: "https://www.yamawa.tw/product/cd/drills/index.htm",
    children: [
      {
        value: "1-1",
        label: "螺絲攻",
        url: "http://html.szktr.cn/yamawa-taps.html",
      },
      {
        value: "1-2",
        label: "螺紋铣刀",
        url: "http://html.szktr.cn/yamawa-mc.html",
      },
    ],
  },
  {
    value: "7",
    label: "三菱",
    iframeUrl: "https://www.mitsubishicarbide.net/mmsc/zh/product_list/",
    children: [
      {
        value: "1-1",
        label: "三菱",
        url: "http://html.szktr.cn/sl.html",
      },
    ],
  },
  {
    value: "8",
    label: "OSG",
    iframeUrl:
      "https://www.tosg.com.tw/index.php?action=products_single&cid=1&id=7&lang=1",
    children: [
      {
        value: "1-1",
        label: "螺丝攻",
      },
      {
        value: "1-2",
        label: "TOSG转造丝攻",
      },
      {
        value: "1-3",
        label: "TOSG螺帽丝攻",
      },
      {
        value: "1-4",
        label: "钻头",
      },
      {
        value: "1-5",
        label: "铣刀",
      },
    ],
  },
  {
    value: "9",
    label: "正河源",
    iframeUrl: "https://www.chain-headway.com.cn/insert-pcd",
    children: [
      {
        value: "1-1",
        label: "刀片",
        desc: "适用切削多种材料精密刀片-车削刀片、牙齿刀片、走心式刀片、铣削刀片、刀片刀片(PCD刀片)、刀片刀片(PCBN刀片)、毛刀片刀片",
      },
      {
        value: "1-2",
        label: "铣削",
        desc: "提供各式铣削刀具-平面铣削、曲面铣削、模具铣削、腔体铣削、镜面加工等多种刀具适用于机械制造、模具产业、电子3C产业、航太产业、微小零部件加工。",
      },
      {
        value: "1-3",
        label: "钻孔",
      },
      {
        value: "1-4",
        label: "侧铣",
        desc: "侧铣刀系列-舍弃式侧铣刀、T形槽端铣刀、直柄小径侧铣刀、锁牙式小径侧铣刀、舍弃式槽铣刀，多种材质刀片选择",
      },
      {
        value: "1-5",
        label: "倒角",
        desc: "倒角刀系列產品種類齊全，除一般45°、60°、30° 倒角刀系列产品种类齐全，除一般45°、60°、30°等倒角刀外，还有小径倒角刀、可调式倒角刀、多钻轴床倒角刀、碳化钨钢小径倒角刀、长刃型倒角刀等多种款式，可满足不同工件的倒角需求。",
      },
    ],
  },
];

export const JINLU = [
  {
    urlForeground: null,
    fileSystemList: [
      {
        id: 223638,
        filename: "2110_车削",
        name: "2110_车削",
        groupid: "catalogue--2110",
        url: "D:/filesProd/images/catalogue/2110_车削.jpg",
        uploadtime: "2023-10-12 13:56:55",
        linno: 1,
      },
    ],
    level: "1",
    memo: null,
    label: "车削",
    showFlag: null,
    izShowParam: true,
    izShowCompetingGoods: true,
    parentCode: "21",
    izNonStandard: false,
    children: [
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223646,
            filename: "211001_普通车削刀片",
            name: "211001_普通车削刀片",
            groupid: "catalogue--211001",
            url: "D:/filesProd/images/catalogue/211001_普通车削刀片.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "普通车削刀片",
        showFlag: null,
        izShowParam: true,
        izShowCompetingGoods: true,
        parentCode: "2110",
        izNonStandard: false,
        children: [],
        izShowProductSelection: true,
        id: 10,
        describe: "普通车削刀片",
        catalogueCode: "211001",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223647,
            filename: "211002_普通车削刀杆",
            name: "211002_普通车削刀杆",
            groupid: "catalogue--211002",
            url: "D:/filesProd/images/catalogue/211002_普通车削刀杆.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "普通车削刀杆",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2110",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 11,
        describe: "普通车削刀杆",
        catalogueCode: "211002",
      },
    ],
    izShowProductSelection: true,
    id: 2,
    describe: "车削加工",
    catalogueCode: "2110",
  },
  {
    urlForeground: null,
    fileSystemList: [
      {
        id: 223639,
        filename: "2120_螺纹",
        name: "2120_螺纹",
        groupid: "catalogue--2120",
        url: "D:/filesProd/images/catalogue/2120_螺纹.jpg",
        uploadtime: "2023-10-12 13:56:55",
        linno: 1,
      },
    ],
    level: "1",
    memo: null,
    label: "螺纹",
    showFlag: "N",
    izShowParam: null,
    izShowCompetingGoods: null,
    parentCode: "21",
    izNonStandard: false,
    children: [
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 260889,
            filename: "212001_螺纹车削刀片",
            name: "212001_螺纹车削刀片",
            groupid: "catalogue--212001",
            url: "D:/filesProd/images/catalogue/212001_螺纹车削刀片.jpg",
            uploadtime: "2023-12-07 10:29:10",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "螺纹车削刀片",
        showFlag: null,
        izShowParam: true,
        izShowCompetingGoods: true,
        parentCode: "2120",
        izNonStandard: false,
        children: [],
        izShowProductSelection: true,
        id: 12,
        describe: "螺纹车削刀片",
        catalogueCode: "212001",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223649,
            filename: "212002_螺纹车削刀杆",
            name: "212002_螺纹车削刀杆",
            groupid: "catalogue--212002",
            url: "D:/filesProd/images/catalogue/212002_螺纹车削刀杆.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "螺纹车削刀杆",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2120",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 13,
        describe: "螺纹车削刀杆",
        catalogueCode: "212002",
      },
    ],
    izShowProductSelection: null,
    id: 3,
    describe: "螺纹加工",
    catalogueCode: "2120",
  },
  {
    urlForeground: null,
    fileSystemList: [
      {
        id: 223640,
        filename: "2130_切断切槽",
        name: "2130_切断切槽",
        groupid: "catalogue--2130",
        url: "D:/filesProd/images/catalogue/2130_切断切槽.jpg",
        uploadtime: "2023-10-12 13:56:55",
        linno: 1,
      },
    ],
    level: "1",
    memo: null,
    label: "切断切槽",
    showFlag: "N",
    izShowParam: null,
    izShowCompetingGoods: null,
    parentCode: "21",
    izNonStandard: false,
    children: [
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223650,
            filename: "213001_切断切槽刀片",
            name: "213001_切断切槽刀片",
            groupid: "catalogue--213001",
            url: "D:/filesProd/images/catalogue/213001_切断切槽刀片.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "切断切槽刀片",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2130",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 14,
        describe: "切断切槽刀片",
        catalogueCode: "213001",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223651,
            filename: "213002_切断切槽刀杆",
            name: "213002_切断切槽刀杆",
            groupid: "catalogue--213002",
            url: "D:/filesProd/images/catalogue/213002_切断切槽刀杆.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "切断切槽刀杆",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2130",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 15,
        describe: "切断切槽刀杆",
        catalogueCode: "213002",
      },
    ],
    izShowProductSelection: null,
    id: 4,
    describe: "切断切槽",
    catalogueCode: "2130",
  },
  {
    urlForeground: null,
    fileSystemList: [
      {
        id: 223641,
        filename: "2140_铣削",
        name: "2140_铣削",
        groupid: "catalogue--2140",
        url: "D:/filesProd/images/catalogue/2140_铣削.jpg",
        uploadtime: "2023-10-12 13:56:55",
        linno: 1,
      },
    ],
    level: "1",
    memo: null,
    label: "铣削",
    showFlag: null,
    izShowParam: true,
    izShowCompetingGoods: true,
    parentCode: "21",
    izNonStandard: false,
    children: [
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223652,
            filename: "214001_整体硬质合金立铣刀",
            name: "214001_整体硬质合金立铣刀",
            groupid: "catalogue--214001",
            url: "D:/filesProd/images/catalogue/214001_整体硬质合金立铣刀.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "整体硬质合金立铣刀",
        showFlag: null,
        izShowParam: true,
        izShowCompetingGoods: true,
        parentCode: "2140",
        izNonStandard: false,
        children: [],
        izShowProductSelection: true,
        id: 16,
        describe: "整体硬质合金立铣刀",
        catalogueCode: "214001",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223653,
            filename: "214002_标准铣削刀片",
            name: "214002_标准铣削刀片",
            groupid: "catalogue--214002",
            url: "D:/filesProd/images/catalogue/214002_标准铣削刀片.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "标准铣削刀片",
        showFlag: null,
        izShowParam: true,
        izShowCompetingGoods: true,
        parentCode: "2140",
        izNonStandard: false,
        children: [],
        izShowProductSelection: true,
        id: 17,
        describe: "可转位铣削刀片",
        catalogueCode: "214002",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223654,
            filename: "214003_可转位铣削刀体",
            name: "214003_可转位铣削刀体",
            groupid: "catalogue--214003",
            url: "D:/filesProd/images/catalogue/214003_可转位铣削刀体.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "可转位铣削刀体",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2140",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 18,
        describe: "可转位铣削刀体",
        catalogueCode: "214003",
      },
    ],
    izShowProductSelection: true,
    id: 5,
    describe: "铣削加工",
    catalogueCode: "2140",
  },
  {
    urlForeground: null,
    fileSystemList: [
      {
        id: 223642,
        filename: "2150_孔加工",
        name: "2150_孔加工",
        groupid: "catalogue--2150",
        url: "D:/filesProd/images/catalogue/2150_孔加工.jpg",
        uploadtime: "2023-10-12 13:56:55",
        linno: 1,
      },
    ],
    level: "1",
    memo: null,
    label: "孔加工",
    showFlag: null,
    izShowParam: true,
    izShowCompetingGoods: false,
    parentCode: "21",
    izNonStandard: false,
    children: [
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 260888,
            filename: "215001_整体钻头",
            name: "215001_整体钻头",
            groupid: "catalogue--215001",
            url: "D:/filesProd/images/catalogue/215001_整体钻头.jpg",
            uploadtime: "2023-12-07 10:29:10",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "整体钻头",
        showFlag: null,
        izShowParam: true,
        izShowCompetingGoods: false,
        parentCode: "2150",
        izNonStandard: false,
        children: [],
        izShowProductSelection: true,
        id: 19,
        describe: "整体硬质合金钻头",
        catalogueCode: "215001",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223656,
            filename: "215002_可转位钻削刀片",
            name: "215002_可转位钻削刀片",
            groupid: "catalogue--215002",
            url: "D:/filesProd/images/catalogue/215002_可转位钻削刀片.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "可转位孔加工刀片",
        showFlag: null,
        izShowParam: true,
        izShowCompetingGoods: false,
        parentCode: "2150",
        izNonStandard: false,
        children: [],
        izShowProductSelection: true,
        id: 20,
        describe: "可转位孔加工刀片",
        catalogueCode: "215002",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223657,
            filename: "215003_可转位钻削刀体",
            name: "215003_可转位钻削刀体",
            groupid: "catalogue--215003",
            url: "D:/filesProd/images/catalogue/215003_可转位钻削刀体.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "可转位孔加工刀体",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2150",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 21,
        describe: "可转位孔加工刀体",
        catalogueCode: "215003",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 528887,
            filename: "215004_小径镗刀",
            name: "215004_小径镗刀",
            groupid: "catalogue--215004",
            url: "D:/filesProd/images/catalogue/215004_小径镗刀.jpg",
            uploadtime: "2025-01-13 16:55:27",
            linno: 1,
          },
        ],
        level: "2",
        memo: "25.1.10卢家鸿新增层级",
        label: "小径镗刀",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: false,
        parentCode: "2150",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 16214,
        describe: "小径镗刀",
        catalogueCode: "215004",
      },
    ],
    izShowProductSelection: true,
    id: 6,
    describe: "孔加工",
    catalogueCode: "2150",
  },
  {
    urlForeground: null,
    fileSystemList: [
      {
        id: 223643,
        filename: "2160_小零件",
        name: "2160_小零件",
        groupid: "catalogue--2160",
        url: "D:/filesProd/images/catalogue/2160_小零件.jpg",
        uploadtime: "2023-10-12 13:56:55",
        linno: 1,
      },
    ],
    level: "1",
    memo: null,
    label: "小零件",
    showFlag: null,
    izShowParam: null,
    izShowCompetingGoods: null,
    parentCode: "21",
    izNonStandard: false,
    children: [
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223658,
            filename: "216001_小零件车削刀片",
            name: "216001_小零件车削刀片",
            groupid: "catalogue--216001",
            url: "D:/filesProd/images/catalogue/216001_小零件车削刀片.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: "新增层级缺少图片",
        label: "小零件车削刀片",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2160",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 22,
        describe: "小零件车削刀片",
        catalogueCode: "216001",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223659,
            filename: "2级缺图1014x286",
            name: "2级缺图1014x286",
            groupid: "catalogue--216002",
            url: "D:/filesProd/images/catalogue/2级缺图1014x286.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: "新增层级缺少图片",
        label: "小零件车削刀杆",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2160",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 23,
        describe: "小零件车削刀杆",
        catalogueCode: "216002",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223660,
            filename: "2级缺图1014x286",
            name: "2级缺图1014x286",
            groupid: "catalogue--216003",
            url: "D:/filesProd/images/catalogue/2级缺图1014x286.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: "【与孔加工层级有重复】新增层级缺少图片",
        label: "整体硬质合金钻头",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2160",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 24,
        describe: "整体硬质合金钻头",
        catalogueCode: "216003",
      },
    ],
    izShowProductSelection: null,
    id: 7,
    describe: "小零件加工",
    catalogueCode: "2160",
  },
  {
    urlForeground: null,
    fileSystemList: [
      {
        id: 223644,
        filename: "2170_超硬刀具",
        name: "2170_超硬刀具",
        groupid: "catalogue--2170",
        url: "D:/filesProd/images/catalogue/2170_超硬刀具.jpg",
        uploadtime: "2023-10-12 13:56:55",
        linno: 1,
      },
    ],
    level: "1",
    memo: null,
    label: "超硬刀具",
    showFlag: null,
    izShowParam: null,
    izShowCompetingGoods: null,
    parentCode: "21",
    izNonStandard: false,
    children: [
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223661,
            filename: "2级缺图1014x286",
            name: "2级缺图1014x286",
            groupid: "catalogue--217001",
            url: "D:/filesProd/images/catalogue/2级缺图1014x286.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: "新增层级缺少图片",
        label: "金属陶瓷刀具",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2170",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 25,
        describe: "金属陶瓷刀具",
        catalogueCode: "217001",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223662,
            filename: "217002_PCBN刀具",
            name: "217002_PCBN刀具",
            groupid: "catalogue--217002",
            url: "D:/filesProd/images/catalogue/217002_PCBN刀具.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: "新增层级缺少图片",
        label: "PCBN刀具",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2170",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 26,
        describe: "PCBN刀具",
        catalogueCode: "217002",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 223663,
            filename: "217003_PCD刀具",
            name: "217003_PCD刀具",
            groupid: "catalogue--217003",
            url: "D:/filesProd/images/catalogue/217003_PCD刀具.jpg",
            uploadtime: "2023-10-12 13:56:55",
            linno: 1,
          },
        ],
        level: "2",
        memo: "新增层级缺少图片",
        label: "PCD刀具",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2170",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 27,
        describe: "PCD刀具",
        catalogueCode: "217003",
      },
    ],
    izShowProductSelection: null,
    id: 8,
    describe: "超硬刀具",
    catalogueCode: "2170",
  },
  {
    urlForeground: null,
    fileSystemList: [
      {
        id: 223645,
        filename: "2180_工具系统及配件",
        name: "2180_工具系统及配件",
        groupid: "catalogue--2180",
        url: "D:/filesProd/images/catalogue/2180_工具系统及配件.jpg",
        uploadtime: "2023-10-12 13:56:55",
        linno: 1,
      },
    ],
    level: "1",
    memo: null,
    label: "工具系统及配件",
    showFlag: "N",
    izShowParam: null,
    izShowCompetingGoods: null,
    parentCode: "21",
    izNonStandard: false,
    children: [
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 260790,
            filename: "218001_BT工具系统",
            name: "218001_BT工具系统",
            groupid: "catalogue--218001",
            url: "D:/filesProd/images/catalogue/218001_BT工具系统.jpg",
            uploadtime: "2023-12-07 10:29:10",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "BT工具系统",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2180",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 28,
        describe: "BT工具系统",
        catalogueCode: "218001",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 260791,
            filename: "218002_HSK工具系统",
            name: "218002_HSK工具系统",
            groupid: "catalogue--218002",
            url: "D:/filesProd/images/catalogue/218002_HSK工具系统.jpg",
            uploadtime: "2023-12-07 10:29:10",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "HSK工具系统",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2180",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 29,
        describe: "HSK工具系统",
        catalogueCode: "218002",
      },
      {
        urlForeground: null,
        fileSystemList: [
          {
            id: 467624,
            filename: "218003_刀柄配件",
            name: "218003_刀柄配件",
            groupid: "catalogue--218003",
            url: "D:/filesProd/images/catalogue/218003_刀柄配件.jpg",
            uploadtime: "2024-06-11 11:34:14",
            linno: 1,
          },
        ],
        level: "2",
        memo: null,
        label: "刀柄配件",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2180",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 30,
        describe: "刀柄配件",
        catalogueCode: "218003",
      },
    ],
    izShowProductSelection: null,
    id: 9,
    describe: "工具系统及配件",
    catalogueCode: "2180",
  },
  {
    urlForeground: null,
    fileSystemList: null,
    level: "1",
    memo: "",
    label: "非标",
    showFlag: "Y",
    izShowParam: null,
    izShowCompetingGoods: null,
    parentCode: "21",
    izNonStandard: false,
    children: [
      {
        urlForeground: null,
        fileSystemList: null,
        level: "2",
        memo: "",
        label: "可转位刀片",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "31",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 14898,
        describe: "",
        catalogueCode: "3101",
      },
      {
        urlForeground: null,
        fileSystemList: null,
        level: "2",
        memo: "",
        label: "整体刀具",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "31",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 14899,
        describe: "",
        catalogueCode: "3102",
      },
      {
        urlForeground: null,
        fileSystemList: null,
        level: "2",
        memo: "",
        label: "超硬刀具",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "31",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 14903,
        describe: "",
        catalogueCode: "3103",
      },
      {
        urlForeground: null,
        fileSystemList: null,
        level: "2",
        memo: "",
        label: "其他",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "31",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 14906,
        describe: "",
        catalogueCode: "3104",
      },
    ],
    izShowProductSelection: null,
    id: 14897,
    describe: "",
    catalogueCode: "31",
  },
  {
    urlForeground: null,
    fileSystemList: [
      {
        id: 264843,
        filename: "2190_丝锥",
        name: "2190_丝锥",
        groupid: "catalogue--2190",
        url: "D:/filesProd/images/catalogue/2190_丝锥.jpg",
        uploadtime: "2024-02-04 11:19:52",
        linno: 1,
      },
    ],
    level: "1",
    memo: null,
    label: "丝锥",
    showFlag: null,
    izShowParam: null,
    izShowCompetingGoods: null,
    parentCode: "21",
    izNonStandard: false,
    children: [
      {
        urlForeground: null,
        fileSystemList: null,
        level: "2",
        memo: null,
        label: "挤压丝锥",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2190",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 15817,
        describe: "挤压丝锥",
        catalogueCode: "219001",
      },
      {
        urlForeground: null,
        fileSystemList: null,
        level: "2",
        memo: null,
        label: "螺旋丝锥",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2190",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 15818,
        describe: "螺旋丝锥",
        catalogueCode: "219002",
      },
      {
        urlForeground: null,
        fileSystemList: null,
        level: "2",
        memo: null,
        label: "刃倾角丝锥",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2190",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 15819,
        describe: "刃倾角丝锥",
        catalogueCode: "219003",
      },
      {
        urlForeground: null,
        fileSystemList: null,
        level: "2",
        memo: null,
        label: "直槽丝锥",
        showFlag: null,
        izShowParam: null,
        izShowCompetingGoods: null,
        parentCode: "2190",
        izNonStandard: false,
        children: [],
        izShowProductSelection: null,
        id: 15820,
        describe: "直槽丝锥",
        catalogueCode: "219004",
      },
    ],
    izShowProductSelection: null,
    id: 15816,
    describe: "丝锥",
    catalogueCode: "2190",
  },
];
